<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="model.pkid ? '编辑' : '新建'"
      class="edit"
      width="850px"
      top="5vh"
      @close="reset()">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <div class="vm-separate">
        <el-form-item label="客户类别" prop="product">
          <el-select v-model="model.product" placeholder="请输入" style="width: 100%">
            <el-option
                v-for="item in productOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="机房类型" prop="computerRoomTyp">
          <el-select v-model="model.computerRoomTyp" placeholder="请输入" style="width: 100%">
            <el-option
                v-for="item in computerRoomTypOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
          </el-select>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="功率" prop="inverterPower">
          <el-input v-model="model.inverterPower" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="尺寸" prop="boxSize">
          <el-input v-model="model.boxSize" placeholder="请输入"/>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="净重" prop="netWeight">
          <el-input v-model="model.netWeight" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="毛重" prop="grossWeight">
          <el-input v-model="model.grossWeight" placeholder="请输入"/>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="柜体型号" prop="cabinetType">
          <el-input v-model="model.cabinetType" placeholder="请输入"/>
        </el-form-item>
        <div/>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>
<script>
  export default {
    name:"ThyssenMarkRuleEdit",
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        productOptions: [{
          value: 0,
          label: "中山",
        }, {
          value: 1,
          label: "上海",
        }],
        computerRoomTypOptions: [{
          value: 0,
          label: "无机房",
        }, {
          value: 1,
          label: "有机房",
        }],
        model: {
          pkid: 0,
          product: "",
          computerRoomTyp: "",
          inverterPower: "",
          cabinetType: "",
          boxSize: "",
          netWeight: "",
          grossWeight: "",
        },
        ruleValidate: {
          product: {required: true, message: "不能为空", trigger: ["blur", "change"]},
          computerRoomTyp: {required: true, message: "不能为空", trigger: ["blur", "change"]},
          inverterPower: {required: true, message: "不能为空", trigger: "blur"},
          boxSize: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.dialogVisible = true;
        this.model.pkid = id;
        if (id > 0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `thyssenMarkRules/${this.model.pkid}`)
          .then(resp => {
            this.model = resp;
          });
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http.save("basic", "thyssenMarkRules", this.model)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$message.success("保存成功");
                this.$emit("save-success");
              })
              .catch(() => {
                this.submitLoading = false;
                this.$message.error("保存失败");
              });
          }
        });
      },
      reset() {
        this.$reset("form");
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>